// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"1497f180","265":"ba5bfd10","361":"7a69e8b5","488":"b8e5b725","520":"dd56f2a2","577":"3685b1ed","780":"a0d6b576"}[chunkId] + ".chunk.js";
};